import qs from 'qs';
import { pushHistory } from './updateHistory';
function clearFiltersFromSearch({ history, location }) {
    const currentSearch = qs.parse(location.search, { ignoreQueryPrefix: true });
    const filteredKeys = ['multiList', 'boolean', 'list', 'range'];
    const safeKeys = Object.keys(currentSearch).filter(key => !filteredKeys.includes(key));
    const filteredSearch = safeKeys.reduce((acc, curr) => {
        return Object.assign(Object.assign({}, acc), { [curr]: currentSearch[curr] });
    }, {});
    return pushHistory({
        history,
        pathname: location.pathname,
        hash: location.hash,
        search: filteredSearch,
        resetPage: true,
        routeType: 'filterChange'
    });
}
export { clearFiltersFromSearch };
//# sourceMappingURL=clearFiltersFromSearch.js.map